import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUKGInvoices, uploadUKGInvoice, deleteUKGInvoice, updateUKGInvoice, getAPARReport } from '../../../../store/actions/';
import Grid from '../../../../components/grid';
import FileUpload from '../../../../components/file-upload';
import Portal from '../../../../components/portal';
import ReportDateRange from '../../../../components/reportDateRange';
import Loader from '../../../../components/loader';
import { Buffer } from 'buffer';
import { LastMonth } from '../../../../utils/date-ranges';
import Edit_icon from '../../../../assets/images/edit_icon.png';
import Delete_icon from '../../../../assets/images/delete_icon.png';
import View_icon from '../../../../assets/images/search.png';
import APARReportView from "./report-view";
import OurModal from '../../../../components/ourModal';

class UKGInvoices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            ukgInvoices: [],
            showPopup: false,
            showEditPopup: false,
            editData: {},
            confirmationBox: false,
            startDate: LastMonth.from,
            endDate: LastMonth.to,
            columnDefs: [
                {
                    headerName: 'Invoice Number',
                    field: 'invoiceNumber',
                    flex: 1
                },
                {
                    headerName: 'Invoice Date',
                    field: 'invoiceDate',
                    cellRenderer: (params) => new Date(params.value).toLocaleDateString(),
                    flex: 1
                },
                {
                    headerName: 'Billing Period',
                    valueGetter: (params) => {
                        const from = new Date(params.data.billingFrom);
                        const to = new Date(params.data.billingTo);
                        return `${from.toLocaleDateString()} - ${to.toLocaleDateString()}`;
                    },
                    flex: 1
                },
                {
                    headerName: 'Actions',
                    field: "",
                    cellRenderer: (params) => (
                        <>
                            <div className="action">
                                <button className="btn btn-primary" disabled={this.state.reportLoading} title='View Invoice' onClick={() => { this.openReportView(params.data) }}><img src={View_icon} /></button>
                                <button className="btn btn-primary" disabled={this.state.reportLoading} title='Edit Billing Period' onClick={() => this.changeDates(params.data)} ><img src={Edit_icon} /></button>{" "}
                                <button className="btn btn-primary" disabled={this.state.reportLoading} title='Delete Invoice' onClick={() => this.toggleConfirmationPopup(params.data.invoiceNumber)}><img src={Delete_icon} /></button>
                            </div>

                        </>)
                }
            ]
        };
    }
    async componentDidMount() {
        await this.props.getUKGInvoices();
        this.setState({
            ukgInvoices: this.props.UKG_INVOICES || [],
            loading: false,
        });
    };

    changeDates = (data) => {
        this.setState({
            editData: data,
            showEditPopup: true,
        });
    };

    /*   getReport = async (paramsData) => {
          const { invoiceNumber, invoiceDate, billingFrom, billingTo } = paramsData;
          this.setState({ reportLoading: true })
          await this.props.getAPARReport({ invoiceNumber, startDate: billingFrom, endDate: billingTo });
          let reportData = (this.props.APAR_REPORT || []).filter(comp => {
              return Object.values(comp).find(val => typeof val === 'object');
          });
          this.setState({
              reportData,
              viewReport: true,
              selectedInvoice: invoiceNumber,
              selectedInvDate: invoiceDate,
              selectedFrom: billingFrom,
              selectedTo: billingTo,
              reportLoading: false
          });
      }; */

    openReportView = paramsData => {
        this.setState({
            viewReport: true,
            paramsData
        });
    };

    handleSelectFile = (e, drop) => {
        let file = drop ? e.dataTransfer.files[0] : e.target.files[0];
        if (!file) return;
        let reader = new FileReader();
        this.setState({
            file: file,
            fileConvertError: null,
            newHireFileName: file.name,
        });
        reader.readAsDataURL(file);
        reader.onload = (res) =>
            this.setState({
                src: res.target.result,
            });
    };

    handleUploadFile = async () => {
        if (!this.state.src) return;
        this.setState({ loading: true });
        const i = this.state.src.indexOf("base64,");
        const buffer = Buffer.from(this.state.src.slice(i + 7), "base64");
        const file = new File([buffer], "name", {
            type: "text/csv",
        });

        const fd = new FormData();
        fd.append("file", file);
        fd.append("filename", file.name);
        fd.append("startDate", Number(this.state.startDate));
        fd.append("endDate", Number(this.state.endDate));
        await this.props.uploadUKGInvoice(fd);
        await this.props.getUKGInvoices();
        this.setState({
            ukgInvoices: this.props.UKG_INVOICES || [],
            loading: false,
            showPopup: false,
        });
    };
    handleDateChange = (startDate, endDate) => {
        this.setState({ startDate, endDate });
    };

    deleteInvoice = async (id) => {
        this.setState({ loading: true });
        await this.props.deleteUKGInvoice(id);
        await this.props.getUKGInvoices();
        this.setState({
            ukgInvoices: this.props.UKG_INVOICES || [],
            loading: false,
            confirmationBox: false,
            editData: {},
        });
    };

    toggleConfirmationPopup = (invoiceNumber) => {
        let { editData } = this.state;
        editData.invoiceNumber = invoiceNumber;
        this.setState({ confirmationBox: !this.state.confirmationBox, editData });
    };

    handleSelectRange = (selected) => {
        this.handleDateChange(selected.from, selected.to);
    };

    handleDateRangeEdit = (startDate, endDate) => {
        this.setState({ startDate, endDate });
    };

    updateBillingPeriod = async () => {
        const { editData, startDate, endDate } = this.state;
        let { invoiceNumber } = editData;
        this.setState({ loading: true });
        await this.props.updateUKGInvoice({ invoiceNumber, billingFrom: Date.parse(startDate), billingTo: Date.parse(endDate) });
        await this.props.getUKGInvoices();
        this.setState({ loading: false, showEditPopup: false, ukgInvoices: this.props.UKG_INVOICES || [] });
    };

    render() {
        const {
            ukgInvoices,
            loading,
            showPopup,
            showEditPopup,
            editData,
            confirmationBox,
            viewReport,
            paramsData
        } = this.state;
        return (
            <div className="">
                <h2 className="">UKG Invoices</h2>
                <button className='btn btn-primary'
                    onClick={() => this.setState({ showPopup: true })}
                >Upload Invoice</button>
                {showPopup && (
                    <Portal
                        zIndex="101"
                        height="600px"
                        width="400px"
                        title="Upload UKG Invoice"
                        close={() => this.setState({ showPopup: false })}
                    >
                        <ReportDateRange
                            startUpRange={LastMonth}
                            handleDateRange={this.handleDateChange}
                            handleSelect={this.handleSelectRange}
                        />
                        {loading ? <Loader /> : <FileUpload
                            HtmlFor="ukg-invoices-upload"
                            CAPTION="Upload UKG Invoice File"
                            FileError={"fileError"}
                            OnSelectFile={this.handleSelectFile}
                            UploadFile={this.handleUploadFile}
                            Accept=".csv"
                            ButtonText="Upload"
                        />}
                    </Portal>
                )}
                {showEditPopup && (
                    <Portal
                        zIndex="101"
                        height="600px"
                        width="400px"
                        title="Edit Billing Period"
                        close={() => this.setState({ showEditPopup: false })}
                    >
                        <ReportDateRange
                            startDate={editData.billingFrom}
                            endDate={editData.billingTo}
                            handleDateRange={this.handleDateRangeEdit}
                        />
                        <button className='btn btn-primary' onClick={this.updateBillingPeriod}>Update</button>
                    </Portal>
                )}
                {confirmationBox && (
                    <OurModal
                        zIndex="101"
                        centered={true}
                        size='small'
                        onClose={this.toggleConfirmationPopup}
                        title="Confirmation"
                        onSave={() => this.deleteInvoice(editData.invoiceNumber)}
                        saveBtnText="Delete"
                    >
                        <p>Are you sure you want to delete?</p>
                    </OurModal>
                )}
                {viewReport && (
                    <OurModal
                        size='large'
                        centered={true}
                        onClose={() => this.setState({ viewReport: false })}
                        title={`AP/AR Report View`}
                        closeOnly={true}
                    >
                        <APARReportView
                            paramsData={paramsData}
                        />

                    </OurModal>
                )}
                <Grid
                    rowData={ukgInvoices}
                    columnDefs={this.state.columnDefs}
                    loading={loading}
                    className="ukg-invoices-grid"
                    domLayout="autoHeight"
                />
            </div>
        );
    }
}

const mapStateToProps = ({ APARComparisonReducer }) => {
    const { UKG_INVOICES, UKG_INVOICE, APAR_REPORT } = APARComparisonReducer;
    return { UKG_INVOICES, UKG_INVOICE, APAR_REPORT };
};

export default connect(mapStateToProps, {
    getUKGInvoices,
    uploadUKGInvoice,
    deleteUKGInvoice,
    updateUKGInvoice,
    getAPARReport
})(UKGInvoices);